import React, { useState, useEffect } from "react";
import { Carousel, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { collection, query, where, getDocs } from "firebase/firestore";
import { preloadImage } from "../../Components/PreloadImages";
import { db } from "../../firebase";
import CustomSkeleton from "../CustomSkeleton/index";
import "./main-banners.css"; // Import the external CSS file

function MainBanners() {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      setImagesLoaded(false);
      const bannerCollectionRef = collection(db, "images");
      const q = query(bannerCollectionRef, where("service", "==", "Home"));

      try {
        const bannerSnapshot = await getDocs(q);
        const bannerData = bannerSnapshot.docs.map((doc) => doc.data());

        if (bannerData.length > 0) {
          await Promise.all(bannerData.map((banner) => preloadImage(banner.url)));
          setBanners(bannerData);
        }

        await new Promise((resolve) => setTimeout(resolve, 2000));
      } catch (error) {
        console.error("Error fetching banner data: ", error);
      } finally {
        setImagesLoaded(true);
      }
    };

    fetchBanners();
  }, []);

  return (
    <div className="container-fluid position-relative p-0 set_max_width_banner">
      <Carousel
        variant="dark"
        interval={3000}
        nextIcon={<span className="carousel-control-next-icon" aria-hidden="true"></span>}
        prevIcon={<span className="carousel-control-prev-icon" aria-hidden="true"></span>}
        indicators={false}
        fade={false}
        pause={false}
        wrap={true}
        keyboard={true}
        slide={true}
      >
        {!imagesLoaded ? (
          <>
            <Carousel.Item>
              <div className="my-auto carousel-item-container">
                <CustomSkeleton height="650px" width="100%" />
                <Carousel.Caption className="d-md-block" style={{ marginBottom: "190px" }}>
                  <CustomSkeleton width="300px" height="40px" />
                  <CustomSkeleton width="400px" height="20px" className="mt-2" />
                  <div className="mt-5 position-absolute left-50">
                    <CustomSkeleton width="150px" height="45px" className="me-3" />
                    <CustomSkeleton width="150px" height="45px" />
                  </div>
                </Carousel.Caption>
              </div>
            </Carousel.Item>

            <Carousel.Item>
              <div className="my-auto carousel-item-container">
                <CustomSkeleton height="650px" width="100%" />
                <Carousel.Caption className="d-md-block" style={{ marginBottom: "190px" }}>
                  <CustomSkeleton width="300px" height="40px" />
                  <CustomSkeleton width="400px" height="20px" className="mt-2" />
                  <div className="mt-5 position-absolute left-50">
                    <CustomSkeleton width="150px" height="45px" className="me-3" />
                    <CustomSkeleton width="150px" height="45px" />
                  </div>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          </>
        ) : (
          banners.map((banner, index) => (
            <Carousel.Item key={index}>
              <div className="my-auto carousel-item-container">
                <img src={banner.url} className="d-block w-100 object-fit-cover" alt={`Slide ${index + 1}`} height={650} />
                <Carousel.Caption className="d-md-block">
                  <h6 className="fs-1 mt-0 mt-md-5 mt-lg-5">{banner.heading}</h6>
                  <p className="fs-4 mb-5">{banner.paragraph}</p>
                  <div className="mt-5 position-absolute left-50 btn-grp">
                    <a href="/Book_Services">
                      <Button variant="primary" className="read_more">
                        Book a Service
                      </Button>
                    </a>
                    <a href="/Contact-us">
                      <Button variant="primary" className="get_a_quote">
                        Get a Quote
                      </Button>
                    </a>
                  </div>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          ))
        )}
      </Carousel>
    </div>
  );
}

MainBanners.defaultProps = {
  banners: [],
};

export default MainBanners;
